export default {
      id: "icon-status-on-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#icon-status-on",
      toString: function () {
        return this.url;
      }
    }